// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { getV1Subscriptions, getV1Taxonomy, type Options, patchV1Subscriptions } from '../sdk.gen';
import type { GetV1SubscriptionsData, GetV1SubscriptionsResponse, GetV1TaxonomyData, GetV1TaxonomyResponse, PatchV1SubscriptionsData, PatchV1SubscriptionsResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const getV1TaxonomyQueryKey = (options?: Options<GetV1TaxonomyData>) => createQueryKey('getV1Taxonomy', options);

/**
 * Get all notification classes
 */
export const getV1TaxonomyOptions = (options?: Options<GetV1TaxonomyData>) => queryOptions<GetV1TaxonomyResponse, DefaultError, GetV1TaxonomyResponse, ReturnType<typeof getV1TaxonomyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1Taxonomy({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1TaxonomyQueryKey(options)
});

export const getV1SubscriptionsQueryKey = (options?: Options<GetV1SubscriptionsData>) => createQueryKey('getV1Subscriptions', options);

/**
 * Read the current configuration of notification class subscriptions
 *
 * Returns subscriptions scoped to the application specified by `app`, or all applications
 * when `app` is omitted.
 *
 * Categorical channel subscriptions are represented by the top-level `channels` property.
 * Subscriptions for each notification class can be configured separately, but if the whole
 * channel is disabled, no notifications through that channel will be delivered. Channels
 * that are not available for a class cannot be turned on.
 *
 * Only leaf classes are included. It is up to the UI to allow enabling or disabling
 * channels on other levels.
 *
 */
export const getV1SubscriptionsOptions = (options?: Options<GetV1SubscriptionsData>) => queryOptions<GetV1SubscriptionsResponse, DefaultError, GetV1SubscriptionsResponse, ReturnType<typeof getV1SubscriptionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1Subscriptions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1SubscriptionsQueryKey(options)
});

/**
 * Update the notification class subscription configuration
 *
 * Updates subscriptions scoped to the application specified by `app`, or all applications
 * when `app` is omitted.
 *
 * There might be differences between the input and the output. For example, classes that
 * cannot be enabled will stay disabled. Forced channels cannot be altered.
 *
 */
export const patchV1SubscriptionsMutation = (options?: Partial<Options<PatchV1SubscriptionsData>>): UseMutationOptions<PatchV1SubscriptionsResponse, DefaultError, Options<PatchV1SubscriptionsData>> => {
    const mutationOptions: UseMutationOptions<PatchV1SubscriptionsResponse, DefaultError, Options<PatchV1SubscriptionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchV1Subscriptions({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
